import React from 'react';
import {Tag, Button} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

interface PermissionTagProps {
  dashboard?: any;
}
export const PermissionTag: React.FC<PermissionTagProps> = ({
  dashboard,
}) => {
  // 权限判断逻辑
  const userId = sessionStorage.getItem('agimx_user_id') || '';
  const isCreator = dashboard?.createUserId === userId;
  const currentDashboardPermission = dashboard?.permission || 'NONE';
    console.log("dashboard in PermissionTag:", {userId, dashboard, isCreator, currentDashboardPermission});
    
  const renderPermissionTag = () => {
    // if (!userId) return null;
    let text, color, icon;

    if (isCreator) {
      text = '全部权限';
      color = 'success';
      icon = <CheckCircleOutlined />;
    } else if (currentDashboardPermission === 'NONE') {
      text = '无权限';
      color = 'error';
      icon = <CloseCircleOutlined />;
    } else if (currentDashboardPermission === 'READ') {
      text = '仅浏览';
      color = 'warning';
      icon = <ExclamationCircleOutlined />;
    } else if (currentDashboardPermission === 'ALL') {
      text = '全部权限';
      color = 'success';
      icon = <CheckCircleOutlined />;
    }

    return (
      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
        <Tag
          icon={icon}
          color={color}
          className="permission-tag"
          style={{
            borderRadius: '20px',
            padding: '4px 12px',
            fontSize: '13px',
            fontWeight: '500',
            border: 'none',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        >
          {text}
        </Tag>
        {isCreator && (
          <Tag
            color="default"
            className="creator-tag"
            style={{
              borderRadius: '20px',
              padding: '4px 12px',
              fontSize: '12px',
              fontWeight: '400',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              color: 'rgba(0, 0, 0, 0.7)'
            }}
          >
            创建者: 我
          </Tag>
        )}
      </div>
    );
  };

  return renderPermissionTag();
};
